// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as AccountAction} from '../../../profile/account/duck';
import {actions as ContactActions} from '../../../configure/general/duck';
import AccountConfig from '../components/AccountConfig';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    country: state.currency.country,
    contactTypes: state.information.contactTypes,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...AccountAction,
        ...ContactActions,
      },
      dispatch
    )
)(AccountConfig);
